// Module
var code = "<img src=\"/assets/img/LOW_RES_IMAGE.jpg\" width=\"225\" height=\"225\" data-src=\"/assets/img/FULL_RES_IMAGE.jpeg\" js-image js-observer-threshold=\"0\" js-observer-root-margin=\"0px 0px 0px 0px\">";
// Exports
export default code;